import * as React from 'react';
import {
    Button,
    FormControl,
    FormGroup,
    ControlLabel,
    HelpBlock,
    Row,
    Col,
    Checkbox
} from 'react-bootstrap';
import FormValidationService from '../../shared/form/FormValidationService';
import { Translate } from '../../shared/LanguageService';
import FormSelect from '../../components/common/FormSelect';

interface ISelectPlanTemplateProps {
    onChange: (e: any) => void;
    planTemplates: any[];
    planTemplateId?: string;
    planTemplateIdName?: string;
    defaultPlanTemplateId?: string;
    overrideDefaultPlanTemplate: boolean;
    overrideDefaultPlanTemplateName?: string;
    errors: any;
}
const SelectPlanTemplate = (props: ISelectPlanTemplateProps) => {
    return (
        <Row>
            <Col md={6}>
                <FormGroup
                    validationState={FormValidationService.getValidationState(
                        props.errors.planTemplateId
                    )}
                >
                    <ControlLabel>{Translate('broker/form/plan-template')}</ControlLabel>
                    <FormSelect
                        name={
                            props.planTemplateIdName !== undefined
                                ? props.planTemplateIdName
                                : 'planTemplateId'
                        }
                        value={
                            props.overrideDefaultPlanTemplate && props.planTemplateId
                                ? props.planTemplateId
                                : props.defaultPlanTemplateId
                                ? props.defaultPlanTemplateId
                                : ''
                        }
                        disabled={!props.overrideDefaultPlanTemplate}
                        onChange={props.onChange}
                    >
                        {!props.defaultPlanTemplateId && (
                            <option value={''}>
                                {Translate('broker/form/plan-template/default')}
                            </option>
                        )}
                        {props.planTemplates.map((x: any) => {
                            return (
                                <option value={x.id} key={x.id}>
                                    {x.name}
                                </option>
                            );
                        })}
                    </FormSelect>
                    <HelpBlock>{props.errors.planTemplateId}</HelpBlock>
                </FormGroup>
            </Col>
            <Col md={6} className="no-label">
                <FormGroup>
                    <Checkbox
                        name={
                            props.overrideDefaultPlanTemplateName !== undefined
                                ? props.overrideDefaultPlanTemplateName
                                : 'overrideDefaultPlanTemplate'
                        }
                        checked={
                            props.overrideDefaultPlanTemplate
                                ? props.overrideDefaultPlanTemplate
                                : false
                        }
                        onChange={props.onChange}
                    >
                        <span>{Translate('broker/form/override-default-plan-template')}</span>
                    </Checkbox>
                </FormGroup>
            </Col>
        </Row>
    );
};

export default SelectPlanTemplate;
